<script setup lang="ts">

const { theme } = useAppConfig()
const props = withDefaults(defineProps<{
  articles: any[],
  type?: 'list' | 'card',
  cols?: number,
  gap?: number | string,
}>(), {
  type: 'list'
})

const borderBtm = computed(() => {
  return `bb-1px-${theme.codeBg}`
})

function openDetail(article: any) {
  navigateTo(`${article.path}`, {
    open: {
      target: '_blank'
    }
  })
}
</script>

<template>
  <div class="article-list">

      <div class="relative box">
        <Transition>
          <div v-if="props.type === 'list'" style="width: 100%;">
            <ul>
              <li v-for="article in props.articles" :key="article.id"
                  class="flex cursor-pointer bb-1-solid bc-[var(--border-color)] pb-vh-15px mb-vh-15px" @click="openDetail(article)">
                <div class="cover w-vh-60px h-vh-60px border-rd-8px flex-shrink-0" :style="{ 'background': 'var(--icon-bg)' }">
                  <Html5Outlined class="w-full h-full text-24px justify-center color-[#fff]" />
                </div>
                <div class="article-info ml-15px flex flex-col justify-around flex-1">
                  <h3 class="text-14px font-700 truncate-1 color-[var(--title-color)]">{{ article.title }}</h3>
                  <div class="flex justify-between items-center"><p class="text-12px truncate-1">标签：<span>{{article.tags || ''}}</span></p> <span
                      class="text-12px flex-grow-0 flex-shrink-0">{{ article.date || $dayjs().format('YYYY-MM-DD') }}</span></div>
                </div>
              </li>
            </ul>
          </div>
          <div v-else class="grid grid-cols-1 gap-15px grid-cols-3 " style="width: 100%;">
            <ArticleCard v-for="article in props.articles" :article="article" :key="article.id"/>
          </div>
        </Transition>
      </div>
  </div>
</template>

<style scoped lang="scss">
    .article-list {
      overflow: hidden;

      /* 下面我们会解释这些 class 是做什么的 */
      .v-enter-active,
      .v-leave-active {
        transition: all 0.6s ease-in-out;
      }

      .v-leave-to {
        opacity: 0;
        transform: translateX(100%);
        position: absolute;
        top: 0;
      }

      .v-enter-from {
        opacity: 0;
        transform: translateX(-100%);
      }

      .v-enter-to,
      .v-leave-from {
        transform: translateX(0);
        opacity: 1;
      }

    }

    .box::after {
      content: "";
      display: block;
      clear: both;
      visibility: hidden;
      height: 0;
    }
</style>